const valuesInit = async function() {
	const { default: CountUp } = await import("../countUp.min.js");
	const countNums = () => {
		const numbersObserver = new IntersectionObserver( ( entries, observer ) => {
			entries.forEach( entry => {
				if (entry.isIntersecting) {
					let suffix = entry.target.dataset.suffix || "";

					if ( typeof suffix === "string" && suffix.trim() !== "" && suffix.match(/[a-zA-Z]/) ) {
						suffix = " " + suffix;
					}

					const count = new CountUp(
						entry.target.id,
						0,
						entry.target.dataset.num,
						0,
						entry.target.dataset.duration || 4, {
						separator: "",
						suffix: suffix
					});

					count.start( () => {
						entry.target.parentElement.classList.add( "numbers__item_done" );
					});

					observer.unobserve( entry.target );
				}
			} ); 
		} );
		document.querySelectorAll( ".values__indicators--item div" ).forEach( num => {
			numbersObserver.observe( num );
		} ); 
	};
	countNums(); 
};
 
themeUtils.loadBlock( valuesInit, "values", ".values" );

